module.exports = __webpack_public_path__ + "static/media/thoughts.c8aa86b9.jpg";